var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChevroneDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5121 14.4999L5.1621 7.1499C4.9121 6.8999 4.62043 6.77907 4.2871 6.7874C3.95376 6.79573 3.6621 6.9249 3.4121 7.1749C3.1621 7.4249 3.0371 7.71657 3.0371 8.0499C3.0371 8.38323 3.1621 8.6749 3.4121 8.9249L11.0871 16.6249C11.2871 16.8249 11.5121 16.9749 11.7621 17.0749C12.0121 17.1749 12.2621 17.2249 12.5121 17.2249C12.7621 17.2249 13.0121 17.1749 13.2621 17.0749C13.5121 16.9749 13.7371 16.8249 13.9371 16.6249L21.6371 8.9249C21.8871 8.6749 22.0079 8.37907 21.9996 8.0374C21.9913 7.69574 21.8621 7.3999 21.6121 7.1499C21.3621 6.8999 21.0704 6.7749 20.7371 6.7749C20.4038 6.7749 20.1121 6.8999 19.8621 7.1499L12.5121 14.4999Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevroneDown);
export default __webpack_public_path__ + "static/media/ChevroneDown.5f85b2621d4b78f25b62b260ba2fcb23.svg";
export { ForwardRef as ReactComponent };